import { PageWorkflowStatus } from 'shared/types/global'

import { Bubble } from './Styles'
import { ReactComponent as CheckIcon } from './icons/check.svg'
import { ReactComponent as EyeIcon } from './icons/eye.svg'
import { ReactComponent as PencilIcon } from './icons/pencil.svg'

type PageStatusProps = {
  withIcon?: boolean
  status: PageWorkflowStatus
  size?: number
}

const ICON_MAP = {
  [PageWorkflowStatus.final]: CheckIcon,
  [PageWorkflowStatus.inProgress]: PencilIcon,
  [PageWorkflowStatus.inReview]: EyeIcon
}

const PageStatus: React.FC<PageStatusProps> = ({
  withIcon = false,
  status,
  size = 16
}) => {
  const IconComponent =
    ICON_MAP[status as keyof typeof ICON_MAP] ?? null

  return (
    <Bubble status={status} size={size}>
      {withIcon && IconComponent ? <IconComponent /> : null}
    </Bubble>
  )
}

export default PageStatus
